<template>
  <div class="container">
    <iframe
      :src="iframeSrc"
      width="100%"
      height="100%"
      frameborder="0"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
import { getAiAgentFlowUrl } from '@/utils/wujieConfig'
export default {
  components: {},
  data() {
    return {
      iframeSrc: getAiAgentFlowUrl(), // 替换为你想要加载的网页
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onIframeLoad() {
      console.log('IFrame 加载完成');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  width: 100vw;
  background: red;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f0f2f5;
}
</style>
